import { BulkActionProgressList, RecipeProgressList } from '../types/reducers/progress'
import {
    SET_BULK_ACTION_PROGRESS,
    SET_RECIPE_PROGRESS,
    SetBulkActionProgress,
    SetRecipeProgress,
} from '../constants/reducers/progress'

export const setBulkActionProgress = (progress: BulkActionProgressList): SetBulkActionProgress => ({
    type: SET_BULK_ACTION_PROGRESS,
    progress,
    receivedAt: Date.now(),
})

export const setRecipeProgress = (progress: RecipeProgressList): SetRecipeProgress => ({
    type: SET_RECIPE_PROGRESS,
    progress,
    receivedAt: Date.now(),
})
